import { useEffect, useState } from 'react'

const DATA_VERSION = 'v2'
const DATA_URL = `/data/menu.${DATA_VERSION}.json`
const LS_KEY = `menuData:${DATA_VERSION}`

export function useMenuDataJson() {
  const [data, setData] = useState(null)
  const [status, setStatus] = useState('loading') // loading | ready | error

  useEffect(() => {
    const abortController = new AbortController()
    const timeoutId = setTimeout(() => abortController.abort(), 8000)

    try {
      const cached = localStorage.getItem(LS_KEY)
      if (cached) {
        const parsed = JSON.parse(cached)
        setData(parsed)
      }
    } catch {}

    async function load() {
      try {
        const res = await fetch(`${DATA_URL}?t=${Date.now().toString().slice(0,10)}`, {
          signal: abortController.signal,
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const json = await res.json()
        setData(json)
        setStatus('ready')
        try {
          localStorage.setItem(LS_KEY, JSON.stringify(json))
        } catch {}
      } catch (err) {
        setStatus((prev) => (data ? 'ready' : 'error'))
      } finally {
        clearTimeout(timeoutId)
      }
    }

    load()
    return () => {
      abortController.abort()
      clearTimeout(timeoutId)
    }
  }, [])

  return { data, status }
}


